import styled from "styled-components";

export const StyledListItemIcon = styled.div`
    display: inline-flex;
    min-width: 38px;
    flex-shrink: 0;
`;